const findMapObjectsByAreaSelection = (
  [start, end],
  { dx, dy, spaces, pins, devices, xScale, yScale, transform: t }
) => {
  const x1 = start[0] - dx * t.k
  const y1 = start[1] - dy * t.k
  const x2 = end[0] - dx * t.k
  const y2 = end[1] - dy * t.k
  let result

  spaces.ids.forEach((id, i) => {
    const space = spaces.byId[id]
    const x = xScale(space.x)
    const y = yScale(space.y)

    if (x1 <= x && x2 >= x && y1 <= y && y2 >= y) {
      result = result ? [...result, space.id] : [space.id]
    }
  })

  pins.ids.forEach((id, i) => {
    const pin = pins.byId[id]
    const x = xScale(pin.map.x)
    const y = yScale(pin.map.y)

    if (x1 <= x && x2 >= x && y1 <= y && y2 >= y) {
      result = result ? [...result, pin.id] : [pin.id]
    }
  })

  devices.ids.forEach((id, i) => {
    const pin = devices.byId[id]
    const x = xScale(pin.map.x)
    const y = yScale(pin.map.y)

    if (x1 <= x && x2 >= x && y1 <= y && y2 >= y) {
      result = result ? [...result, pin.id] : [pin.id]
    }
  })

  return result
}

export default findMapObjectsByAreaSelection
